import React, { Component, Fragment, type ReactElement } from 'react'
import company from '../../images/company.mp4'
import companyMission from '../../images/company-mission.svg'
import Footer from '../../common/Footer/Footer'
import WhiteTitle from '../../common/WhiteTitle/WhiteTitle'
import images from '../../common/images'
import { leaderships } from './Leadership/Leadership'
import { advisor } from './Leadership/Advisor'
import LeadershipCard from './Leadership/LeadershipCard'
import AdvisorCard from './Leadership/AdvisorCard'
import HeaderWrapper from '../../common/Header/HeaderWrapper/HeaderWrapper'
import HamburgerMenuHandler from '../../common/Header/HeaderHandler/HamburgerMenuHandler'
import SideBarMenuMobile from '../../common/SideBarMenuMobile/SideBarMenuMobile'
import BackToTop from '../../common/BackToTop/BackToTop'
import LoadingState from '../../common/LoadingState/LoadingState'
import { managers } from './Leadership/Managership'
import ManagershipCard from './Leadership/ManagershipCard'
import './style.scss'

class Company extends Component {
  componentDidMount(): void {
    document.title = 'IVA｜AI × ヒトで、世界にもっと輝きを。｜会社概要'
    document.addEventListener('wheel', this.handleScroll)
    document.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount(): void {
    document.removeEventListener('wheel', this.handleScroll)
    document.removeEventListener('scroll', this.handleScroll)
  }

  render(): ReactElement {
    return (
      <Fragment>
        <div className='company main-content'>
          <LoadingState />
          <HeaderWrapper shouldShowBlackLogo={true} />
          <BackToTop />
          <WhiteTitle
            pageTitle={images.companyPageTitle}
            title=''
            title2=''
            titleWidth='160px'
            subtitle=''
            subtitle2=''
          />
          <div style={{ position: 'relative' }}>
            <video autoPlay={true} controls={false} muted loop={true} playsInline width='100%'>
              <source src={company} type='video/mp4' />
              Sorry, your browser does not support videos.
            </video>
            <div className='company-missionTitle'>
              <div className='company-missionLabel'>
                <img alt='MISSION' src={companyMission} /><span>私たちの使命</span>
              </div>
              <span className='company-missionDivider' aria-hidden='true'></span>
              <div className='company-missionText'>
                <h1>
                  モノの可能性を最大化し、
                  <br />
                  価値経済の統合基盤を築く。
                </h1>
                <p>
                  Maximize the Potential of Assets.
                  <br />
                  Build the Foundation of the Value Economy.
                </p>
              </div>
            </div>
          </div>

          <section className='company-vision' aria-labelledby='company-vision-heading'>
            <div className='company-visionLayout'>
              <div className='company-visionIntro'>
                <h2 className='company-visionLabel' id='company-vision-heading'>
                  VISION <span>私たちの野望</span>
                </h2>
                <div className='company-visionHeadline'>
                  <h3>
                    価値の覚醒で、
                    <br />
                    世界に熱狂を。
                  </h3>
                  <p>Unlock Value. Power the World.</p>
                </div>
              </div>
              <div className='company-visionBody'>
                <p>世界には未だ、ポテンシャルを秘めた価値が無数にある。</p>
                <p>
                  真価を見出されず、過小に評価されている価値。
                  <br />
                  忘れ去られ、巡ることなく眠り続けている価値。
                  <br />
                  信頼という壁に阻まれ、流動性を失っている価値。
                </p>
                <p>
                  私たちは、あらゆる価値を解き放つ。
                  <br />
                  価値が正しく見出され、適切に評価され、自在に巡る世界へ。
                </p>
                <p>
                  モノも、人も、企業も、社会も。
                  <br />
                  あらゆる価値が、本来の可能性を発揮できる世界をつくる。
                </p>
              </div>
            </div>
          </section>

          <div className='company-aboutUsAndLeadership'>
            <div className='company-aboutUs content-padding container title-wrapper'>
              <span className='title-with-bg-wrapper'>
                <i className='title-animation'></i>
                <span className='title-with-bg'>ABOUT US</span>
                <span className='subtitle-with-bg'>会社概要</span>
              </span>

              <div className='company-aboutUsTable section-animation'>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>会社名</span>
                    <span>IVA株式会社 (IVA Co.,Ltd.)</span>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent company-aboutUsRowLarge'>
                    <span className='company-aboutUsRowTitle'>所在地</span>
                    <div>
                      <p>150-6145 東京都渋谷区渋谷2-24-12 渋谷スクランブルスクエア 45F</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent company-aboutUsRowLarge'>
                    <span className='company-aboutUsRowTitle'>代表者</span>
                    <div>
                      <p>相原嘉夫</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>設立</span>
                    <span>2019年4月</span>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>資本金</span>
                    <span>5億580万7432円（資本準備金を含む）</span>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>事業内容</span>
                    <div>
                      <p>AI真贋鑑定サービス「フェイクバスターズ」の開発及び運営</p>
                      <p>AI即金アプリ「Chalyn（チャリン）」の開発及び運営</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>従業員数</span>
                    <span>81名（2026年10月現在）</span>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>株主</span>
                    <div className='company-aboutUsLargeContent pt-0'>
                      <p className='mb-0'>経営陣</p>
                      <p className='mb-0'>株式会社メルカリ</p>
                      <p className='mb-0'>千葉道場ファンド</p>
                      <p className='mb-0'>横浜キャピタル</p>
                      <p className='mb-0'>De Capital 1号投資事業有限責任組合</p>
                      <p className='mb-0'>De Capital株式会社</p>
                      <p className='mb-0'>NEW COMMERCE VENTURES</p>
                      <p className='mb-0'>ビッグブル１号投資事業有限責任組合</p>
                      <p className='mb-0'>KSK Angel Fund, LLC</p>
                      <p className='mb-0'>個人投資家</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>主要取引銀行</span>
                    <div>
                      <p>みずほ銀行</p>
                      <p>りそな銀行</p>
                      <p>他多数</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>顧問</span>
                    <div className='company-aboutUsLargeContent pt-0'>
                      <p className='mb-0'>法律事務所KenRi</p>
                      <p className='mb-0'>AZX社会保険労務士事務所</p>
                      <p className='mb-0'>ASC社会保険労務士法人</p>
                      <p className='mb-0'>TIP税理士法人</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>関連会社</span>
                    <div className='company-aboutUsLargeContent pt-0'>
                      <p className='mb-0'>Shanghai Zhibieyunjian Technology Co., Ltd.</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow'>
                  <div className='company-aboutUsRowContent'>
                    <span className='company-aboutUsRowTitle'>古物許可番号</span>
                    <div className='company-aboutUsLargeContent pt-0'>
                      <p className='mb-0'>東京都公安委員会許可 第303312318030号</p>
                    </div>
                  </div>
                </div>
                <div className='company-aboutUsRow company-rowWithLink'>
                  <div className='company-aboutUsRowContent last-content'>
                    <span className='company-aboutUsRowTitle'>加盟団体</span>
                    <div className='company-aboutUsLargeContent pt-0'>
                      <p className='mb-0'>日本流通自主管理協会（AACD）</p>
                      <p className='mb-0'>日本リユース業協会</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='company-leadership content-padding container title-wrapper'>
              <span className='title-with-bg-wrapper'>
                <i className='title-animation'></i>
                <span className='title-with-bg'>BOARD & EXECUTIVE OFFICERS</span>
                <span className='subtitle-with-bg'>経営陣</span>
              </span>

              <div className='company-leadershipCards section-animation'>
                {leaderships.map((leader) => {
                  return <LeadershipCard key={leader.name} leader={leader} />
                })}
              </div>
            </div>

            {/* Management Team 区块 */}
            <div className='company-managership content-padding container title-wrapper'>
              <span className='title-with-bg-wrapper'>
                <i className='title-animation'></i>
                <span className='title-with-bg'>MANAGEMENT TEAM</span>
                <span className='subtitle-with-bg'>マネジメント</span>
              </span>
              <div className='company-managershipCards section-animation'>
                {managers.map((leader) => (
                  <ManagershipCard key={leader.name} leader={leader} />
                ))}
              </div>
            </div>

            <div className='company-leadership content-padding container title-wrapper'>
              <span className='title-with-bg-wrapper'>
                <i className='title-animation'></i>
                <span className='title-with-bg'>PRINCIPAL</span>
                <span className='subtitle-with-bg'>外部顧問</span>
              </span>

              <div className='company-advisorCards section-animation'>
                {advisor.map((leader) => {
                  return <AdvisorCard key={leader.name} leader={leader} />
                })}
              </div>
            </div>
          </div>
          <div className='company-globalOffices content-padding container'>
            <div className='company-globalOfficesTitleWrapper'>
              <div className='title-wrapper'>
                <span className='title-with-bg-wrapper'>
                  <i className='title-animation'></i>
                  <span className='title-with-bg'>GLOBAL OFFICES</span>
                  <span className='subtitle-with-bg'>拠点</span>
                </span>
              </div>
              {/* <p className='company-officesHeadline jp-14'>
              日本とインターナショナルな人材の強みを融合させ、質とスピードを持ち合わせる競争に強い組織を世界各地に保有しています。
            </p> */}
            </div>
            <div className='company-globalOfficesCards section-animation'>
              <div className='company-globalOfficesCard'>
                <div>
                  <img alt='company-japan-office' src={images.japanOffice} />
                  <p className='company-officeCardTitle' style={{ marginTop: '10px' }}>
                    日本東京
                    <br />
                    本社
                  </p>
                </div>
                <div>
                  <p className='company-officeCardContent'>150-6145 東京都渋谷区渋谷2-24-12</p>
                  <p className='company-officeCardContent'>渋谷スクランブルスクエア 45F</p>
                  <p className='company-officeCardContent'>
                    SHIBUYA SCRAMBLE SQUARE 45F, 2-24-12, Shibuya, Shibuya-Ku, Tokyo, Japan
                  </p>
                </div>
              </div>

              <div className='company-globalOfficesCard'>
                <div>
                  <img alt='company-japan-office' src={images.newJapanOffice} />
                  <p className='company-officeCardTitle' style={{ marginTop: '10px' }}>
                    日本東京
                    <br />
                    ロジスティクスセンター
                  </p>
                </div>
                <div>
                  <p className='company-officeCardContent'>
                    150-0011 東京都渋谷区東2-22-5 SHIBUROJI 3F
                  </p>
                  <p className='company-officeCardContent'>
                    SHIBUROJI 3F, 2-22-5 Higashi, Shibuya-Ku, Tokyo, Japan
                  </p>
                </div>
              </div>

              <div className='company-globalOfficesCard'>
                <div>
                  <img
                    alt='company-japan-office'
                    src={images.taiwanOffice}
                    srcSet={`${images.taiwanOffice} x2`}
                  />
                  <p className='company-officeCardTitle' style={{ marginTop: '10px' }}>
                    台湾台北
                    <br />
                    ロジスティクスセンター
                  </p>
                </div>
                <p className='company-officeCardContent'>
                  12F., No. 46, Huaide St., Beitou Dist., Taipei City 112041 , Taiwan (R.O.C.)
                </p>
              </div>
              <div className='company-globalOfficesCard'>
                <div>
                  <img alt='company-japan-office' src={images.chinaOffice} />
                  <p className='company-officeCardTitle' style={{ marginTop: '10px' }}>
                    中国上海 <br />
                    智别云鉴科技有限公司
                    <br />
                    テクニカルオフィス
                  </p>
                </div>
                <p className='company-officeCardContent'>
                  Building 20, No. 1-42, Lane 83, Hongxiang North Road, Wanxiang Town, Pudong New
                  Area, Shanghai, China
                </p>
              </div>
            </div>
          </div>
          <Footer />
        </div>
        <SideBarMenuMobile handler={new HamburgerMenuHandler(true)} />
      </Fragment>
    )
  }

  private readonly handleScroll = (): void => {
    this.handleAnimationElements()
    this.handleSectionAnimation()
  }

  private readonly handleAnimationElements = (): void => {
    const animationElements = document.querySelectorAll('.title-animation')
    const windowHeight = window.innerHeight

    for (let i = 0; i < animationElements.length; i++) {
      const elementTop = animationElements[i].getBoundingClientRect().top
      const elementVisible = 10

      if (elementTop < windowHeight - elementVisible) {
        animationElements[i].classList.add('active')
      } else {
        animationElements[i].classList.remove('active')
      }
    }
  }

  private readonly handleSectionAnimation = (): void => {
    const animationElements = document.querySelectorAll('.section-animation')
    const windowHeight = window.innerHeight

    for (let i = 0; i < animationElements.length; i++) {
      const elementTop = animationElements[i].getBoundingClientRect().top
      const elementVisible = 10

      if (elementTop < windowHeight - elementVisible) {
        animationElements[i].classList.add('active')
      } else {
        animationElements[i].classList.remove('active')
      }
    }
  }
}

export default Company
